import axios from "axios";
const baseurl = process.env.REACT_APP_API_URL;
export const DroneBookingForm = async (data) => {
  const res = await axios({
    method: "post",
    url: baseurl + `/droneBooking`,
    data: data,
  });
  return res.data;
};
